/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { Button } from './ui/button';
import { X } from 'lucide-react';

import Store from './Store';

class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.clear = this.clear.bind(this);
    this.state = { foo: 'bar' };
  }

  clear() {
    Store.data.error = null;
    Store.data.successMsg = null;
    return Store.save();
  }

  render() {
    return (
      <div className="absolute top-14 z-10 w-full">
        <div
          style={{ backgroundColor: this.props.color }}
          className="p-2 text-white"
        >
          <div className="flex items-center">
            <div>{this.props.message}</div>
            <div className="flex-1" />
            <Button
              variant="ghost"
              size="icon"
              onClick={this.clear}
              className="text-white hover:bg-white/10"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Toast;
